module.exports = __webpack_public_path__ + "img/space_dust_grape_back.13c0d5bd.jpg";